import React, { useState } from 'react';

import { AnimatePresence, type AnimationProps } from 'framer-motion';

import { useBreakpoints } from '@pkg/hooks';

import { HoverBackdrop, TriggerWrapper, Wrapper } from './ControlTrigger.styles';

interface ControlTriggerProps {
    children: React.ReactNode;
    optionsElement?: React.ReactElement;
    customAnimation?: AnimationProps;
    onIsHovering?: (isHovering: boolean) => void;
}

const baseAnimation = {
    initial: { opacity: 0, scale: 0.8 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.8 },
};

export function ControlTrigger({ children, optionsElement, customAnimation, onIsHovering }: ControlTriggerProps) {
    const { isMobile } = useBreakpoints();
    const [isHovering, setIsHovering] = useState(false);

    const showControls = isHovering || isMobile;

    function handleHover(hovering: boolean) {
        setIsHovering(hovering);
        onIsHovering?.(hovering);
    }

    const animation = customAnimation || baseAnimation;

    const triggerMarkup = <TriggerWrapper {...animation}>{optionsElement}</TriggerWrapper>;

    return (
        <Wrapper onMouseEnter={() => handleHover(true)} onMouseLeave={() => handleHover(false)}>
            {children}
            <AnimatePresence initial={false}>{triggerMarkup}</AnimatePresence>
            <HoverBackdrop $isVisible={showControls} />
        </Wrapper>
    );
}
